<template>
    <router-link to="/" class="logo">
        <img src="/images/logo.svg" />
    </router-link>
</template>
<script>
export default {
    
}
</script>